import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IChecklistTicket } from '../../../../interfaces/checklist-ticket.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-checklist-ticket-pdf',
  templateUrl: './checklist-ticket-pdf.component.html',
  styleUrls: ['./checklist-ticket-pdf.component.scss'],
  standalone: false,
})
export class ChecklistTicketPdfComponent {
  isLoading = false;

  @Input() ticket: IChecklistTicket;
  @Input() downloadPdf: (ticket: IChecklistTicket) => Observable<HttpResponse<Blob>>;

  constructor(private cdr: ChangeDetectorRef) {}

  public handleDownloadPdf(ticket: IChecklistTicket): void {
    if (!this.downloadPdf || this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.downloadPdf(ticket)
      .pipe(catchError(() => of(null)))
      .subscribe(() => {
        this.isLoading = false;
        this.cdr.markForCheck();
      });
  }
}
